// import React, { useState, useEffect } from "react";
// import Navbar from "./Components/NavBar/Navbar";
// import ProgressBar from "./Components/ProgressBar/ProgressBar";

// import Footer from "./Components/Footer/Footer";
// import { Outlet } from "react-router-dom";
// import ScrollToTopButton from "./Components/ScrollTopIcon/ScrollToTopButton";
// import Loader from "./Components/Loader/Loader";  
// import PopupCTA from "./Components/CTAButton/PopupCTA";  

// function Layout() {
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   if (loading) {
//     return <Loader />; 
//   }

//   return (
//     <>
//       <Navbar />
//             <ProgressBar/>

//       <main style={{ minHeight: "80vh" }}>
//         <Outlet />
//       </main>
//       <Footer />
//       <ScrollToTopButton />

//       <PopupCTA text="Book Now" link="#contact" />
//     </>
//   );
// }

// export default Layout;


import React, { useState, useEffect } from "react";
import Navbar from "./Components/NavBar/Navbar";
import ProgressBar from "./Components/ProgressBar/ProgressBar";
import Footer from "./Components/Footer/Footer";
import { Outlet, useLocation } from "react-router-dom";
import VenuePlannerShare from "./Components/3DVenuePlanner/VenuePlannerShare/VenuePlannerShare";

import ScrollToTopButton from "./Components/ScrollTopIcon/ScrollToTopButton";
import Loader from "./Components/Loader/Loader";  
import PopupCTA from "./Components/CTAButton/PopupCTA";  
import WhatsAppFloat from "./Components/CTAButton/WhatsAppFloat";
import VenuePopup from "./Components/3DVenuePlanner/VenuePopup/VenuePopup";

function Layout() {
   const location = useLocation();

  // Match /venue-planner and all nested routes.
  const isVenuePlanner = /^\/venue-planner(?:\/|$)/.test(
    location.pathname
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />; 
  }

  return (
    <>
      <Navbar />
      <ProgressBar/>

      <main style={{ minHeight: "80vh" }}>
        <Outlet />
      </main>

      <Footer />
      <ScrollToTopButton />

      <PopupCTA text="Book Now" link="#contact" />

      <WhatsAppFloat
        phoneNumber="919971881444"
        message="Hi, My name is [Your Name], I'm interested in your [Package Name] package. Please share details."
        label="Plan your trip"
      />
            {/* <VenuePopup/> */}
  {/* <VenuePopup hotels={venuePlannerData} /> */}
{isVenuePlanner ? (
  <VenuePlannerShare
    key={`${location.pathname}${location.search}${location.hash}`}
  />
) : (
  <VenuePopup />
)}
    </>
  );
}

export default Layout;